import { FC } from 'react'

import { Popover, Modal } from 'antd'
import styled, { createGlobalStyle } from 'styled-components'
import { useMediaQuery } from 'react-responsive'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { LowBudgetContent } from './LowBudgetContent'

const StyledModal = styled(Modal)`
  margin-right: revert !important;
  .ant-modal {
    width: 358px !important;

    @media (min-width: 768px) {
      width: 344px !important;
    }
  }

  .ant-modal-body {
    width: 358px !important;

    @media (min-width: 768px) {
      width: 344px !important;
    }
  }

  .ant-modal-content {
    border-radius: 16px;
    background-color: ${({ theme }) => theme.color.white};
    padding: 0px !important;
    width: 358px !important;

    @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
      width: 344px !important;
    }
  }

  .ant-modal-close {
    display: none;
  }
`
const LOW_BUDGET_POPOVER_OFFSET_1 = -85
const LOW_BUDGET_POPOVER_OFFSET_2 = -90

export const LowBudgetPopoverStyles = createGlobalStyle`
  .low-budget-popover {
    padding: 0;
    pointer-events: none;
    z-index: 1000;
  }

  .low-budget-popover > * {
    pointer-events: auto;
  }

  .low-budget-popover .ant-popover-arrow {
    display: none;
  }

  .low-budget-popover .ant-popover-inner {
    background: transparent;
    box-shadow: none;
    padding: 0;
  }

  .low-budget-popover .ant-popover-inner-content {
    padding: 0;
  }
`

const DesktopAnchor = styled.div`
  position: absolute;
  top: 120px;
  right: -8px;
  width: 1px;
  height: 1px;
`
export interface LowBudgetAlertProps {
  isLowBudgetVisible: boolean
  onCloseLowBudgetAlert: () => void
}
export const LowBudgetAlert: FC<LowBudgetAlertProps> = ({
  isLowBudgetVisible,
  onCloseLowBudgetAlert,
}) => {
  const isMobile = useMediaQuery({ maxWidth: MAX_MOBILE_WIDTH })

  if (!isLowBudgetVisible) {
    return null
  }

  if (isMobile) {
    return (
      <StyledModal
        centered={true}
        open={isLowBudgetVisible}
        keyboard={true}
        footer={null}
        mask={false}
        onOk={onCloseLowBudgetAlert}
        onCancel={onCloseLowBudgetAlert}
        onClose={onCloseLowBudgetAlert}
      >
        <LowBudgetContent onClose={onCloseLowBudgetAlert} />
      </StyledModal>
    )
  }

  return (
    <>
      <LowBudgetPopoverStyles />
      <Popover
        open
        placement='leftTop'
        content={<LowBudgetContent onClose={onCloseLowBudgetAlert} />}
        align={{
          offset: [LOW_BUDGET_POPOVER_OFFSET_1, LOW_BUDGET_POPOVER_OFFSET_2],
        }}
        classNames={{ root: 'low-budget-popover' }}
        styles={{ root: { width: 344 } }}
        getTooltipContainer={(trigger) =>
          trigger.parentElement || document.body
        }
      >
        <DesktopAnchor />
      </Popover>
    </>
  )
}
